import {h} from 'ui/Framework';

export default h('svg', {
  width: '70',
  height: '50',
  viewBox: '-1 -1 72 52',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#D6DCE4'
    }, [
      h('g', [
        h('path', {
          d: 'M.5.5h30.32v20.319H.5zM39.207.5h30.32v20.319h-30.32zM.5 29.5h30.32v20.319H.5zM39.207 29.5h30.32v20.319h-30.32z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/media-previews-widget.es6.js